import { render, staticRenderFns } from "./FirebaseNotificationList.vue?vue&type=template&id=6e46c6b8&"
import script from "./FirebaseNotificationList.vue?vue&type=script&lang=js&"
export * from "./FirebaseNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./FirebaseNotificationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports